import React, { useRef, useMemo } from 'react';
import styled from '@grebban/style-system-react';
import PropTypes from 'prop-types';

const Wrapper = styled('div')`
    overflow-y: hidden;
`;

const AnimateHeight = ({ minified, children, maxHeight, ...rest }) => {
    // Our wrapper element reference.
    const reference = useRef(null);

    // Determine max-height on the wrapper for the wrapper.
    const calculatedHeight = useMemo(() => {

        // We perform calculations on client.
        if (reference.current) {
            const scrollHeight = reference.current.scrollHeight || 0;
            const maxHeightInteger = parseInt(maxHeight || 0, 10);
            const exceedsMaxHeight = !!maxHeightInteger && scrollHeight > maxHeightInteger;
            const calculatedHeight = exceedsMaxHeight ? maxHeightInteger : scrollHeight;

            // If the animate height wrapper is expanded we should apply new max-height to wrapper.
            return minified ? '0px' : `${calculatedHeight}px`;
        }

        // We just return value on server.
        return minified ? '0px' : maxHeight || 'initial';
    }, [minified, maxHeight, reference.current]);

    return (
        <Wrapper ref={reference} maxHeight={calculatedHeight} {...rest}>
            {children}
        </Wrapper>
    );
};

AnimateHeight.propTypes = {
    children: PropTypes.node.isRequired,
    maxHeight: PropTypes.string,
    minified: PropTypes.bool,
};

AnimateHeight.defaultProps = {
    maxHeight: 'initial',
    minified: true,
};

export default AnimateHeight;
